// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';

import MeetingsQueryLayout from '../meetings-query-layout';

export const SPLIT_PANEL_I18NSTRINGS = {
  preferencesTitle: 'Split panel preferences',
  preferencesPositionLabel: 'Split panel position',
  preferencesPositionDescription: 'Choose the default split panel position for the service.',
  preferencesPositionSide: 'Side',
  preferencesPositionBottom: 'Bottom',
  preferencesConfirm: 'Confirm',
  preferencesCancel: 'Cancel',
  closeButtonAriaLabel: 'Close panel',
  openButtonAriaLabel: 'Open panel',
  resizeHandleAriaLabel: 'Resize split panel',
};

const EMPTY_PANEL_CONTENT = {
  header: '0 meetings selected',
  body: 'Select a meeting to see its details.',
};

export const getPanelContent = (items) => {
  if (!items.length) {
    return EMPTY_PANEL_CONTENT;
  }

  return {
    header: `${items.length} meetings selected`,
    body: <MeetingsQueryLayout />,
  };
};
